document.addEventListener('klaviyo_list_update', async (e) => {
  if (!e.detail || !e.detail.email) return;
  const email = e.detail.email;

  window._learnq = window._learnq || [];
  window._learnq.push(['identify', { $email: email }]);
  window._learnq.push(['subscribe', { list: 'VZzguH' }]);

  try {
    const formData = new URLSearchParams();
    formData.append('g', 'VZzguH'); 
    formData.append('email', email);

    const response = await fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: formData.toString(),
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }
  } catch (error) {
    console.error('Erro to add customer to the Klaviyo list:', error);
  }
});